// Function to format date
export function formatDate(dateTimeString) {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    const date = new Date(dateTimeString).toLocaleDateString(undefined, options);  
    return date ;
   
  }

// Function to format hour
  export function formatHour(dateTimeString) { 
    const timeOptions = { hour: '2-digit' }; 
    const hour = new Date(dateTimeString).toLocaleTimeString(undefined, timeOptions);
    return hour ;  
  }

// Function to format minute
  export function formatMinute(dateTimeString) { 
    const timeOptions = { minute: '2-digit' }; 
    const minute = new Date(dateTimeString).toLocaleTimeString(undefined, timeOptions);
    return minute;  
  }

// Function to format second
  export function formatSecond(dateTimeString) { 
    const timeOptions = { second: '2-digit' }; 
    const second = new Date(dateTimeString).toLocaleTimeString(undefined, timeOptions);
    return second ;  
  }

   // Function to convert coordinates
 export default function convertCoordinates(coordinates){
    const { lat, lng } = coordinates;
    const formattedCoordinates = `${lat}&${lng}`;
    return formattedCoordinates;
  };

  //Function to extract month
 export const getMonthFromDateString = (dateString) => {
    const date = new Date(dateString);
    const month = date.toLocaleString("en-US", { month: "short" });
    return month.slice(0, 3).toUpperCase();
  };

  //Function to convert date into YYYY-MM-DD format
  export function formatDateString(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
  
    return `${year}-${month}-${day}`;
  }

// Function to convert string("Thu Oct 12 2023 00:00:00 GMT+0530 (India Standard Time)") to date

export const extractDate=(input) =>{
  const dateRegExp = /(\d{2})\/(\d{2})\/(\d{2})/;
  const match = input.match(dateRegExp);

  if (match && match.length === 4) {
    const day = match[1];
    const month = match[2];
    const year = match[3];
    return `${day}/${month}/${year}`;
  } else {
    return null; // Return null if the input string does not contain a valid date in the DD/MM/YY format.
  }
}


export const ConvertStringToDate = (dateString) => {
  let date = new Date(dateString);

  // Extract the year, month, and day from the Date object
  let year = date.getFullYear();
  let month = date.getMonth() + 1; // Months are zero-based, so add 1
  let day = date.getDate();

  // Create a formatted date string
  let formattedDate =
    year +
    "-" +
    (month < 10 ? "0" : "") +
    month +
    "-" +
    (day < 10 ? "0" : "") +
    day;

return formattedDate;
};
 
// Get year difference
export const calculateRemainingYears = (endDate) => {
  const currentDate = new Date(); 
  const endWarrantyDate = new Date(endDate); 

  if (endWarrantyDate > currentDate) {
    const timeDifference = endWarrantyDate - currentDate;

    const millisecondsInDay = 24 * 60 * 60 * 1000;
    const remainingDays = Math.floor(timeDifference / millisecondsInDay);

    const years = Math.floor(remainingDays / 365);
    const months = Math.floor((remainingDays % 365) / 30); 
    const days = remainingDays % 30;

    return years;
  } else {
    return 0 
  }
};

// Get month difference

export const calculateRemainingMonths = (endDate) => {
  const currentDate = new Date(); 
  const endWarrantyDate = new Date(endDate); 

  if (endWarrantyDate > currentDate) {
    const timeDifference = endWarrantyDate - currentDate;

    const millisecondsInDay = 24 * 60 * 60 * 1000;
    const remainingDays = Math.floor(timeDifference / millisecondsInDay);

    const years = Math.floor(remainingDays / 365);
    const months = Math.floor((remainingDays % 365) / 30); 
    const days = remainingDays % 30;

    return months;
  } else {
    return 0 
  }
};


export const calculateRemainingDays = (endDate) => {
  const currentDate = new Date();
  const endWarrantyDate = new Date(endDate);

  // Set time components to 00:00:00 for both dates
  currentDate.setHours(0, 0, 0, 0);
  endWarrantyDate.setHours(0, 0, 0, 0);

  if (endWarrantyDate > currentDate || (endWarrantyDate.getTime() === currentDate.getTime() && endWarrantyDate.getHours() >= currentDate.getHours())) {
    const timeDifference = endWarrantyDate - currentDate;

    const millisecondsInDay = 24 * 60 * 60 * 1000;
    const remainingDays = Math.floor(timeDifference / millisecondsInDay);

    // If endWarrantyDate is the same as currentDate or has later hours, return 1
    if (remainingDays === 0) {
      return 1;
    }

    const days = remainingDays % 30;

    return days;
  } else {
    return 0;
  }
};

export const NumberToKFormat = ({ number }) => {
  const convertToK = (num) => {
    return num >= 1000 ? (num / 1000).toFixed(1) + 'k' : num;
  };

  return <span>{convertToK(number)}</span>;
};

export const DateFormattiing = (dateString) => {
  let date = new Date(dateString);

  // Extract the year, month, and day from the Date object
  let year = date.getFullYear();
  let month = date.getMonth() + 1; // Months are zero-based, so add 1
  let day = date.getDate();

  // Create a formatted date string
  let formattedDate =
    year +
    "-" +
    (month < 10 ? "0" : "") +
    month +
    "-" +
    (day < 10 ? "0" : "") +
    day;
  return formattedDate;
};

export const truncateAddress =(address)=> {
  if (address.length <= 20) {
    return address;
  }

  const truncatedAddress = `${address.substring(0, 7)}...${address.slice(-21)}`;
  return truncatedAddress;
}
  
//Function to convert image size from kb to mb
export const convertbytesToKb = (kb) => {
  const mb = kb / 1024;
  return mb.toFixed(2); // Round to 2 decimal places
};


// calculate warranty end date in add asset 
 export  const calculateWarrantyEndDate = (purchaseDate, months) => {
  if (!purchaseDate || !months) return "";

  const start = new Date(purchaseDate);
  const end = new Date(start);

  // Add months
  end.setMonth(end.getMonth() + Number(months));

  return formatDate(end); // reuse your existing formatter
};

// calculate warranty duration from purchase date and expire date

export const calculateWarrantyMonths = (
  purchaseDate,
  warrantyEndDate
) => {
  if (!purchaseDate || !warrantyEndDate) return "NA";

  const start = new Date(purchaseDate);
  const end = new Date(warrantyEndDate);

  if (isNaN(start) || isNaN(end) || end < start) return "NA";

  let months =
    (end.getFullYear() - start.getFullYear()) * 12 +
    (end.getMonth() - start.getMonth());

  // If end day is before start day, reduce one month
  if (end.getDate() < start.getDate()) {
    months -= 1;
  }

  return months > 0 ? `${months} Months` : "0 Months";
};

// 2026-02-10 → February 10, 2026
export const FormattedDateToAlphabets = (date) => {
  if (!date) return "NA";

  const parsed = new Date(date);
  if (isNaN(parsed)) return "NA";

  return parsed.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

// auto-calculate duration in amc/cmc

export const calculateDurationInMonthsAndDays = (start, end) => {
  if (!start || !end) return "";

  const startDate = new Date(start);
  const endDate = new Date(end);

  if (isNaN(startDate) || isNaN(endDate)) return "";
  if (endDate < startDate) return "";

  let years = endDate.getFullYear() - startDate.getFullYear();
  let months = endDate.getMonth() - startDate.getMonth();
  let days = endDate.getDate() - startDate.getDate();

  if (days < 0) {
    // borrow days from previous month
    months--;
    const prevMonth = new Date(endDate.getFullYear(), endDate.getMonth(), 0);
    days += prevMonth.getDate();
  }

  if (months < 0) {
    years--;
    months += 12;
  }

  const totalMonths = years * 12 + months;

  if (totalMonths === 0 && days === 0) return "0 Days";

  let result = [];
  if (totalMonths > 0) result.push(`${totalMonths} Month${totalMonths > 1 ? "s" : ""}`);
  if (days > 0) result.push(`${days} Day${days > 1 ? "s" : ""}`);

  return result.join(" ");
};







  
  